<template>
  <div class="main" id="main">
    <!-- <my-header></my-header> -->
    <router-link to="/" class="close el-icon-circle-close"></router-link>
    <div class="content">
      <el-upload
        class="upload-demo"
        drag
        action="/api/APFAPI/UploadFile"
        multiple
        accept=".zip,.rar,.tar"
        :limit="1"
        :on-success="handleSuccess"
        :on-error="handleError"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">
          只能上传压缩包文件，且不超过20M
        </div>
      </el-upload>
      <router-link to="/" class="cancel">取消</router-link>
    </div>
    <my-upload v-if="show" :res="data" type="0"></my-upload>
  </div>
</template>
<style scoped>
.main {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;

  /* color: white; */
}
.content {
  min-height: 100vh;
  width: 100%;
  position: relative;
  overflow: hidden;
  text-align: center;
  background-color: #f7f9fa;
}
.upload-demo {
  width: 500px;
  margin: 300px auto 0;
}
.close {
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 10;
  font-size: 40px;
  color: #ccc;
  cursor: pointer;
}
.close:hover {
  color: #1caad9;
}
.cancel {
  height: 50px;
  width: 105px;
  display: block;
  position: relative;
  padding: 0 24px;
  margin: 15px auto;
  box-sizing: border-box;
  border: 1px;
  border-color: #1caad9;
  border-style: solid;
  border-radius: 4px;
  font-size: 14px;
  color: #1caad9;
  line-height: 50px;
  letter-spacing: 2px;
  background-color: transparent;
  transition: background-color 0.15s ease;
  cursor: pointer;
}
.cancel:hover{
      background-color: #e8f7fb;
}
</style>
<script>
import https from "@/https.js";
// import MyHeader from "@/components/header.vue";
import MyUpload from "@/components/upload2.vue";
export default {
  components: {
    // MyHeader: MyHeader,
    MyUpload: MyUpload,
  },
  data() {
    return {
      data:{
        id:"",
        modelUrl:""
      },
      show:false,
    };
  },
  created() {
    //this.init();
  },
  methods: {
    handleSuccess(response, file, fileList) {
      console.log(response)
      
      let id = response.id || ''
      if(id!=''){
        this.data.modelUrl = response.filePath;
        this.show = true;
        //this.$router.push({ path: '/admin/modelList' })
      }
    },
    handleError(err){
      if(err.status == '401'){
         this.$router.push({ path: '/login' })
      }
    },
    close() {
      this.show = false;
    },
    saveClose(){
       this.$router.push({ path: '/admin/modelList' })
    }
  },
};
</script>
